import React from "react";
import "./ServicesOverview.css";

export default function ServicesOverview() {
  return (
    <section className="services-overview">
      <h2>How It Works</h2>
      <div className="steps">
        <div className="step">
          <h3>1. Book Online</h3>
          <p>Fill out the pickup form and schedule a time that works for you.</p>
        </div>
        <div className="step">
          <h3>2. We Pick It Up</h3>
          <p>Our driver collects your clothes right from your door.</p>
        </div>
        <div className="step">
          <h3>3. We Deliver Clean</h3>
          <p>Clothes returned fresh, clean, and ready to wear!</p>
        </div>
      </div>
    </section>
  );
}
